import React from "react";
import { Provider } from "react-redux";
import { Outlet } from "react-router-dom";

import Header from "../components/header/Header";
import SideNav from "../components/sidenav/SideNav";

import { store } from "./../store";

const AppLayout = () => {
  // Sidebar is always collapsed (closed) - no toggle functionality
  const isSidebarOpen = false;

  return (
    <div className="layout" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Header - Full width at top - no toggle button */}
      <Header />

      {/* Content area - Sidebar + Main content */}
      <div style={{ display: "flex", flex: 1, overflow: "hidden", marginTop: "60px" }}>
        <SideNav isOpen={isSidebarOpen} />

        <main style={{
          flex: 1,
          marginLeft: "64px", // Always collapsed width
          transition: "margin-left 0.3s ease",
          overflowY: "auto",
          backgroundColor: "#e8e8e8"
        }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

const RootLayout = () => {
  return (
    <div className="App">
      <Provider store={store}>
        <AppLayout />
      </Provider>
    </div>
  );
};

export default RootLayout;
